<template>
  <div>
    <el-table
      :data="simplifyShopsHireLogInfo.owners"
      style="margin-top: 10px"
      border
    >
      <!-- 客户名称 -->
      <el-table-column
        prop="customerName"
        label="客户名称"
        align="center"
        min-width="120"
      ></el-table-column>

      <!-- 商机名称 -->
      <el-table-column
        prop="opportunityName"
        label="商机名称"
        align="center"
        min-width="150"
      ></el-table-column>

      <!-- 负责人 -->
      <el-table-column
        prop="responsiblePerson"
        label="负责人"
        align="center"
        min-width="120"
      ></el-table-column>

      <!-- 商机状态（带样式标签） -->
      <el-table-column label="状态" align="center" min-width="120">
        <template slot-scope="scope">
          <el-tag :type="getStatusTagType(scope.row.status)" size="small">
            {{ getStatusLabel(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>

      <!-- 预计成交日期 -->
      <el-table-column
        prop="expectedDealDate"
        label="预计成交日期"
        align="center"
        min-width="140"
      ></el-table-column>

      <!-- 创建时间 -->
      <el-table-column
        prop="create_time"
        label="创建时间"
        align="center"
        min-width="160"
      ></el-table-column>

      <!-- 操作列 -->
      <el-table-column label="操作" align="center" min-width="100">
        <template slot-scope="scope">
          <el-button size="mini" @click="_openShopsOwnerFee(scope.row)"
            >查看商机</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next"
      :total="total"
      class="pagination"
    ></el-pagination>
  </div>
</template>

<script>
import { queryBusinessOpportunity } from "@/api/businessOpportunity/businessOpportunityApi";
import { getCommunityId } from "@/api/community/communityApi";
import { getDict } from "@/api/community/communityApi";
export default {
  name: "SimplifyShopsHireLog",
  data() {
    return {
      simplifyShopsHireLogInfo: {
        owners: [], // 存储接口返回的商机列表数据
        ownerId: "",
        roomId: "",
      },
      statusOptions: [], // 状态字典数据
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页条数
      total: 0, // 总记录数
      communityId: "", // 社区ID
    };
  },
  created() {
    this.communityId = getCommunityId();
    // 提前加载字典数据，确保在列表渲染前完成
    this.getCustomerOptions();
  },
  methods: {
    // 打开组件并加载数据
    open(params) {
      this.handleSwitch(params);
    },

    // 切换数据并重新加载
    handleSwitch(params) {
      if (!params.roomId) return;
      this.clearSimplifyShopsHireLogInfo();
      Object.assign(this.simplifyShopsHireLogInfo, params);
      // 等待字典加载完成后再请求列表（确保状态能正确解析）
      this.waitDictLoaded().then(() => {
        this.listShopsHireLog();
      });
    },

    // 等待字典数据加载完成（解决异步时机问题）
    waitDictLoaded() {
      return new Promise((resolve) => {
        // 如果字典已加载，直接 resolve
        if (this.statusOptions.length > 0) {
          resolve();
          return;
        }
        // 否则轮询检查，最多等5秒
        const timer = setInterval(() => {
          if (this.statusOptions.length > 0) {
            clearInterval(timer);
            resolve();
          }
        }, 100);
        setTimeout(() => {
          clearInterval(timer);
          resolve(); // 超时后无论如何都继续，避免卡死
        }, 5000);
      });
    },

    // 加载商机租赁日志列表
    async listShopsHireLog() {
      try {
        const params = {
          page: this.currentPage - 1,
          row: this.pageSize,
          communityId: this.communityId,
          roomId: this.simplifyShopsHireLogInfo.roomId,
        };
        const res = await queryBusinessOpportunity(params);
        this.simplifyShopsHireLogInfo.owners = res.data || [];
        this.total = res.total || 0;
      } catch (error) {
        console.error("加载商机租赁日志失败:", error);
        this.$message.error("加载失败");
      }
    },

    // 查看商机详情
    _openShopsOwnerFee(row) {
      this.$router.push({
        path: "/pages/admin/businessOpportunity",
        query: { id: row.id }, // 传递当前商机ID，方便详情页定位
      });
    },

    // 清空组件数据
    clearSimplifyShopsHireLogInfo() {
      this.simplifyShopsHireLogInfo = {
        owners: [],
        ownerId: "",
        roomId: "",
      };
      this.currentPage = 1;
      this.total = 0;
    },

    // 分页页码变化
    handleCurrentChange(val) {
      this.currentPage = val;
      this.listShopsHireLog();
    },

    // 加载状态字典数据
    async getCustomerOptions() {
      try {
        const auditData = await getDict("business_opportunity_status", "audit");
        // 过滤无效数据，只保留有statusCd和description的项
        this.statusOptions = auditData.filter(
          (item) => item.statusCd && item.description
        );
        console.log("状态字典加载完成:", this.statusOptions);
      } catch (error) {
        console.error("获取状态选项失败:", error);
        this.statusOptions = []; // 出错时重置为空，避免使用旧数据
      }
    },

    // 转换状态为中文标签（从字典中匹配）
    getStatusLabel(status) {
      // 容错：如果状态为空，直接返回空
      if (!status) return "";
      // 从字典中查找匹配的描述
      const matchOption = this.statusOptions.find(
        (option) => option.statusCd === status
      );
      // 找到返回描述，否则返回原始状态值
      return matchOption ? matchOption.description : status;
    },

    // 状态标签样式
    getStatusTagType(status) {
      const typeMap = {
        initial_contact: "info",
        demand_confirmation: "primary",
        solution_making: "warning",
        business_negotiation: "purple",
        closed_won: "success",
        closed_lost: "danger",
      };
      return typeMap[status] || "default";
    },
  },
};
</script>

<style scoped>
.pagination {
  margin-top: 15px;
  text-align: right;
}
</style>
